export class XbrlFilingData {
    /**
     * True while the data is still only what was read out of the uploaded files, false once someone saved it by hand.
     * - Read-only here: the server forces it to false on every save, so it must never be posted back.
     */
    isInitial?: boolean;
    /**
     * Read-only, computed by the server: true when every field below that has to come from the filing itself
     * carries a value.
     * - Ignored when posted back, so it keeps reporting the truth even after the data was accepted as-is.
     */
    isValid?: boolean;
    /**
     * The user having accepted the filing data as it stands, knowing it is incomplete.
     * - Posting this as true stops the request being held back; it does NOT make isValid true.
     */
    isAccepted: boolean = false;
    language!: string; //nl/en
    legalEntityName!: string; //Besloten vennootschap
    legalEntityLegalForm!: string; // Micro/Small/Medium/Large
    legalEntityRegisteredOffice!: string; //Veenendaal
    chamberOfCommerceRegistrationNumber!: string;  //12345678
    legalEntityRegisteredType!: string; //Large
    financialReportingPeriodEndDate!: Date; //31-12-2025, non nullable: unset arrives as 0001-01-01
    financialReportingPeriod!: string; //31-12-2025
    financialStatementsConsolidated!: boolean; //Yes/No/Ja/Nee
    auditorsReportFinancialStatementsPresent!: boolean; //Yes/No/Ja/Nee
    documentAdoptionStatus!: boolean; //Yes/No/Ja/Nee
    documentAdoptionDate?: Date; //31-12-2025
    /**
     * True while the adoption above is only what the uploaded KvK file happened to state, false once an actor
     * chose it in the Adopt action.
     * - A chosen adoption is overlaid on every read, so edits to it would silently revert: leave the two
     *   adoption fields read-only while this is false.
     */
    adoptionIsPrefilled?: boolean;
    /**
     * Read-only, computed by the server: adoptionIsPrefilled and an adoption date that carries a value.
     * - What the builder's warning bar is driven by; ignored when posted back.
     */
    hasPrefilledAdoptionDate?: boolean;
    has403Field!: boolean; //Yes/No/Ja/Nee
    has408Field!: boolean; //Yes/No/Ja/Nee
}
